export class CssVarsUtils {
  public static setScreenSizesOnRoot(noVhFixed?: boolean) {

    const vh = window.innerHeight;
    document.documentElement.style.setProperty('--vh', vh + 'px');

    if (noVhFixed !== true) {
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vhfixed', vh + 'px');
    }

    // First we get the viewport height
    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', vw + 'px');
  }

  public static initScreenSizesOnRoot() {

    CssVarsUtils.setScreenSizesOnRoot();

    window.addEventListener('resize', () => {
      CssVarsUtils.setScreenSizesOnRoot(true);
    });

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        CssVarsUtils.setScreenSizesOnRoot();
      }, 200);
    });
  }
}
